export default "__VITE_ASSET__BZmgMrdu__"